import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { FaTimesCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { getSupportedParams, PageLinks, SearchStatus } from '../../../constants';
import { resetSaveTripStatus } from '../../../store/slices/trip';
import ModalSpinner from '..';

const ModalSpinnerSaveTrip = ({ tripId }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { test, advisor } = router.query;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { error, selectedTrips } = useSelector((store) => store.trip);
  const { travelAgency, isLoggedIn } = useSelector((store) => store.user);
  const saveTripStatus = useSelector(
    (store) => (store.trip.selectedTrips[tripId] || {}).saveTripStatus,
  );
  const isBrochurePage = router.pathname.indexOf('brochure') > -1;
  const isDedicatedHotelPage = router.route === PageLinks.DedicatedHotelPage.route;
  const supportedUrlParams =
    travelAgency && travelAgency.settings && travelAgency.settings.supportedUrlParams;
  useEffect(() => {
    if (saveTripStatus === SearchStatus.SEARCHING) {
      setIsModalOpen(true);
    }
    if (saveTripStatus === SearchStatus.DONE) {
      setTimeout(() => {
        setIsModalOpen(false);
      }, 3000);
    }
    if (saveTripStatus === SearchStatus.DONE && !error) {
      const query = {
        tripId:
          selectedTrips && selectedTrips[tripId] && selectedTrips[tripId].tripCode
            ? selectedTrips[tripId].tripCode
            : tripId,
      };
      if (test === 'true') {
        query.test = true;
      }
      if (isBrochurePage) {
        // Carry the brochure id so checkout and booking can be attributed to the proposal.
        query.brochure = typeof router.query.id === 'string' ? router.query.id : '';
      } else if (isDedicatedHotelPage) {
        query.dedicatedHotel = true;
      }
      const filteredParams = getSupportedParams(supportedUrlParams, router);
      Object.assign(query, filteredParams);
      if (advisor) query.advisor = advisor;
      let pathname = '/checkout';
      if (!isLoggedIn) {
        pathname = `/${travelAgency.agencyAliasName}${pathname}`;
      }
      router.push({
        pathname,
        query,
      });
      dispatch(resetSaveTripStatus({ tripId }));
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [saveTripStatus, tripId]);

  return (
    <ModalSpinner isOpen={isModalOpen} size="xs">
      {saveTripStatus === SearchStatus.SEARCHING && (
        <div className="text-theme gap-2 flex flex-col items-center text-center">
          <CircularProgress color="inherit" />
          Please hold on while we&#39;re saving <br /> your selection and redirect to checkout
          page...
        </div>
      )}
      {saveTripStatus === SearchStatus.DONE && error && error.length > 0 && (
        <div className="text-orange-500 gap-2 flex flex-col items-center text-center">
          <p className="flex flex-col items-center">
            <FaTimesCircle size={68} />
            Error in save your changes, please try again.
          </p>
          {error ? <p>{error}</p> : null}
        </div>
      )}
    </ModalSpinner>
  );
};

ModalSpinnerSaveTrip.propTypes = {
  tripId: PropTypes.string,
};

ModalSpinnerSaveTrip.defaultProps = {
  tripId: undefined,
};

export default React.memo(ModalSpinnerSaveTrip);
